import React from 'react';
import { Checkbox } from 'primereact/checkbox';
import { Tag } from 'primereact/tag';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useLanguage } from '../../../../../contexts/LanguageContext';
import { MODULE_ICONS } from '../../constants';

// "Kullanım Tipi" kartları + modül başına "Alt Roller" kutuları
const ModuleRoleSelector = ({ form }) => {
    const { th } = useLanguage();
    const { assignable, assignableLoading, selectedModules, toggleModule, allModulesSelected, toggleAllModules, selectedRoleIds, toggleRole, toggleAllRolesOfModule, effectiveRoleByModule, errors } = form;

    if (assignableLoading || form.rolesLoading) {
        return (
            <div className="flex justify-content-center p-4">
                <ProgressSpinner style={{ width: '2.5rem', height: '2.5rem' }} />
            </div>
        );
    }

    if (assignable.length === 0) {
        return <div className="text-color-secondary p-3">{th('authorizationV2.user.noAssignableRoles')}</div>;
    }

    const moduleLabel = (m) => th(`authorizationV2.modules.${m.moduleCode}`, { fallback: m.moduleName });

    const card = (key, label, icon, selected, onClick) => (
        <div className="col-6 md:col-4 lg:col-2" key={key}>
            <div className={`authz-v2-module-card ${selected ? 'selected' : ''}`} role="checkbox" aria-checked={selected} tabIndex={0} onClick={onClick} onKeyDown={(e) => (e.key === ' ' || e.key === 'Enter') && (e.preventDefault(), onClick())}>
                <i className={icon} />
                <span className="font-medium">{label}</span>
            </div>
        </div>
    );

    return (
        <>
            <h4 className="authz-v2-section-title">{th('authorizationV2.user.usageType')}</h4>
            <div className="grid mb-3">
                {assignable.map((m) => card(m.moduleCode, moduleLabel(m), MODULE_ICONS[m.moduleCode] || 'pi pi-th-large', selectedModules.includes(m.moduleCode), () => toggleModule(m.moduleCode)))}
                {assignable.length > 1 && card('__all', th('authorizationV2.user.allModules'), 'pi pi-th-large', allModulesSelected, toggleAllModules)}
            </div>

            <h4 className="authz-v2-section-title">{th('authorizationV2.user.subRoles')}</h4>
            {errors.roles && <small className="p-error block mb-2">{errors.roles}</small>}
            <div className="grid">
                {assignable.map((m) => {
                    const enabled = selectedModules.includes(m.moduleCode);
                    const ids = m.roles.map((r) => r.roleId);
                    const allChecked = ids.length > 0 && ids.every((id) => selectedRoleIds.includes(id));
                    const effectiveRole = effectiveRoleByModule[m.moduleCode];
                    return (
                        <div className="col-12 md:col-6 lg:col-3" key={m.moduleCode}>
                            <div className={`authz-v2-role-box ${enabled ? '' : 'disabled'}`}>
                                <div className="authz-v2-role-box-title">
                                    <Checkbox inputId={`all-${m.moduleCode}`} checked={enabled && allChecked} disabled={!enabled} onChange={(e) => toggleAllRolesOfModule(m.moduleCode, e.checked)} />
                                    <label htmlFor={`all-${m.moduleCode}`}>{moduleLabel(m)}</label>
                                </div>
                                {m.roles.map((r) => (
                                    <div className="flex align-items-start gap-2 mb-2" key={r.roleId}>
                                        <Checkbox inputId={`role-${r.roleId}`} checked={selectedRoleIds.includes(r.roleId)} disabled={!enabled} onChange={() => toggleRole(r.roleId)} />
                                        <label htmlFor={`role-${r.roleId}`} className={enabled ? 'cursor-pointer' : ''} title={r.roleName}>
                                            {r.description || r.roleName}
                                            {effectiveRole?.roleId === r.roleId && selectedRoleIds.filter((id) => ids.includes(id)).length > 1 && <Tag className="ml-2" severity="info" value={th('authorizationV2.user.effective')} />}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>
                    );
                })}
            </div>
            {form.otherRoles.length > 0 && (
                <div className="mt-2 text-color-secondary">
                    <i className="pi pi-info-circle mr-2" />
                    {th('authorizationV2.user.otherRoles')}: {form.otherRoles.join(', ')}
                </div>
            )}
        </>
    );
};

export default ModuleRoleSelector;
